// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../brand/simam-brand.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Simam Digital — WebXR Showcases hub styles.
 * Standardised, near-black, brand-aligned (see simamdigital.com).
 * Copyright (c) 2026 Simam Digital Ltd.
 */

* {
	box-sizing: border-box;
}

html,
body {
	margin: 0;
	padding: 0;
	min-height: 100%;
}

body {
	font-family: var(--simam-font-body);
	color: var(--simam-text-on-dark);
	background: var(--simam-black);
	-webkit-font-smoothing: antialiased;
}

.page {
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 24px 96px;
}

.eyebrow {
	display: inline-flex;
	align-items: center;
	gap: 9px;
	text-transform: uppercase;
	letter-spacing: 0.16em;
	font-size: 12.5px;
	font-weight: 600;
	color: var(--simam-text-muted-dark);
	margin: 0 0 18px;
}

.eyebrow::before {
	content: '';
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: var(--simam-orange);
}

/* ---- Nav (rounded pill bar) --------------------------------------------- */

.nav {
	position: sticky;
	top: 16px;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin: 18px 0 0;
	padding: 11px 12px 11px 18px;
	background: rgba(16, 18, 24, 0.82);
	border: 1px solid var(--simam-line);
	border-radius: var(--simam-radius-pill);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
}

.nav-brand {
	display: flex;
	align-items: center;
	gap: 11px;
	text-decoration: none;
}

.nav-logo {
	width: 34px;
	height: 34px;
	display: block;
}

.nav-logo svg {
	width: 100%;
	height: 100%;
	display: block;
}

.nav-wordmark {
	font-weight: 800;
	font-size: 17px;
	letter-spacing: 0.04em;
	color: var(--simam-text-on-dark);
}

.nav-links {
	display: flex;
	gap: 4px;
	margin-left: auto;
}

.nav-links a {
	color: var(--simam-text-muted-dark);
	text-decoration: none;
	font-size: 14.5px;
	font-weight: 500;
	padding: 9px 16px;
	border-radius: var(--simam-radius-pill);
	transition: background 0.15s ease, color 0.15s ease;
}

.nav-links a:hover {
	color: var(--simam-text-on-dark);
	background: rgba(255, 255, 255, 0.06);
}

.nav-cta {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	background: var(--simam-orange);
	color: #fff;
	text-decoration: none;
	font-size: 14.5px;
	font-weight: 600;
	padding: 11px 20px;
	border-radius: var(--simam-radius-pill);
	transition: background 0.15s ease;
}

.nav-cta:hover {
	background: var(--simam-orange-hover);
}

/* ---- Hero ---------------------------------------------------------------- */

.hero {
	display: grid;
	grid-template-columns: 1.05fr 0.95fr;
	align-items: center;
	gap: 48px;
	padding: 86px 0 96px;
}

.hero-title {
	font-weight: 800;
	font-size: clamp(40px, 5.6vw, 66px);
	line-height: 1.03;
	letter-spacing: -0.025em;
	margin: 0;
	max-width: 13ch;
}

.hero-sub {
	font-size: clamp(16px, 1.5vw, 18.5px);
	line-height: 1.6;
	color: var(--simam-text-muted-dark);
	margin: 22px 0 32px;
	max-width: 50ch;
}

.hero-cta {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}

.hero-cta a {
	text-decoration: none;
}

/* Re-skin shared buttons for the standardised hub look (no lift/glow) */
.hero-cta .simam-btn {
	font-family: var(--simam-font-body);
	box-shadow: none;
}

.hero-cta .simam-btn:hover {
	transform: none;
	filter: none;
}

.hero-cta .simam-btn--ghost {
	color: var(--simam-text-on-dark);
	border-color: var(--simam-line-strong);
}

.hero-cta .simam-btn--ghost:hover {
	background: rgba(255, 255, 255, 0.06);
	border-color: var(--simam-text-muted-dark);
}

.hero-hint {
	margin-top: 24px;
	font-size: 13px;
	color: var(--simam-text-muted-dark);
	opacity: 0.8;
}

.hero-visual {
	position: relative;
	width: 100%;
	min-height: 420px;
	height: 100%;
}

#hero-canvas {
	width: 100%;
	height: 100%;
	display: block;
}

/* ---- Showcases ----------------------------------------------------------- */

.section-head {
	margin-bottom: 30px;
}

.section-title {
	font-weight: 800;
	font-size: clamp(26px, 3.4vw, 38px);
	letter-spacing: -0.02em;
	margin: 0;
}

.card-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
	gap: 20px;
}

.card {
	display: flex;
	flex-direction: column;
	padding: 26px;
	background: var(--simam-panel);
	border: 1px solid var(--simam-line);
	border-radius: var(--simam-radius-lg);
	transition: transform 0.2s ease, border-color 0.2s ease,
		background 0.2s ease;
}

.card:hover {
	transform: translateY(-4px);
	border-color: var(--simam-line-strong);
	background: var(--simam-panel-2);
}

.card-main {
	display: flex;
	flex-direction: column;
	gap: 14px;
	text-decoration: none;
	color: inherit;
	flex: 1;
}

.card-chip {
	width: 46px;
	height: 46px;
	border-radius: 13px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--card-accent, var(--simam-violet));
	background: color-mix(in srgb, var(--card-accent, #a855f7) 16%, transparent);
}

.card-chip svg {
	width: 24px;
	height: 24px;
}

.card-eyebrow {
	text-transform: uppercase;
	letter-spacing: 0.13em;
	font-size: 11.5px;
	font-weight: 600;
	color: var(--simam-text-muted-dark);
}

.card-title {
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	margin: 0;
}

.card-desc {
	font-size: 14.5px;
	line-height: 1.55;
	color: var(--simam-text-muted-dark);
	margin: 0;
	flex: 1;
}

.card-launch {
	display: inline-flex;
	align-items: center;
	gap: 7px;
	font-weight: 600;
	font-size: 14px;
	color: var(--simam-text-on-dark);
	margin-top: 4px;
}

.card-launch span {
	transition: transform 0.18s ease;
}

.card:hover .card-launch {
	color: var(--card-accent, var(--simam-violet));
}

.card:hover .card-launch span {
	transform: translateX(4px);
}

.card-foot {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
	margin-top: 18px;
	padding-top: 14px;
	border-top: 1px solid var(--simam-line);
}

.card-stat {
	display: inline-flex;
	align-items: center;
	gap: 7px;
	font-size: 12px;
	font-weight: 600;
	color: var(--simam-text-muted-dark);
}

.card-stat::before {
	content: '';
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--card-accent, var(--simam-violet));
}

.card-cs {
	font-size: 12px;
	font-weight: 600;
	color: var(--card-accent, var(--simam-violet));
	text-decoration: none;
	white-space: nowrap;
}

.card-cs:hover {
	text-decoration: underline;
}

/* ---- Funnel band --------------------------------------------------------- */

.funnel {
	margin-top: 64px;
	padding: 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 32px;
	flex-wrap: wrap;
	background: linear-gradient(
		135deg,
		var(--simam-panel-2),
		var(--simam-panel)
	);
	border: 1px solid var(--simam-line);
	border-radius: var(--simam-radius-lg);
}

.funnel-copy {
	max-width: 620px;
}

.funnel-title {
	font-weight: 800;
	font-size: clamp(22px, 3vw, 30px);
	letter-spacing: -0.02em;
	margin: 6px 0 12px;
}

.funnel-sub {
	font-size: 15px;
	line-height: 1.6;
	color: var(--simam-text-muted-dark);
	margin: 0;
}

.funnel-cta {
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
}

.funnel-cta a {
	text-decoration: none;
}

.funnel-cta .simam-btn {
	font-family: var(--simam-font-body);
	box-shadow: none;
}

.funnel-cta .simam-btn:hover {
	transform: none;
	filter: none;
}

.funnel-cta .simam-btn--ghost {
	color: var(--simam-text-on-dark);
	border-color: var(--simam-line-strong);
}

.funnel-cta .simam-btn--ghost:hover {
	background: rgba(255, 255, 255, 0.06);
	border-color: var(--simam-text-muted-dark);
}

/* ---- Footer -------------------------------------------------------------- */

.site-footer {
	margin-top: 72px;
	padding-top: 30px;
	border-top: 1px solid var(--simam-line);
	display: flex;
	justify-content: space-between;
	gap: 24px;
	flex-wrap: wrap;
}

.footer-brand .nav-wordmark {
	font-size: 16px;
}

.footer-meta {
	font-size: 13px;
	color: var(--simam-text-muted-dark);
	text-align: right;
	line-height: 1.7;
}

.footer-links {
	display: flex;
	gap: 16px;
	justify-content: flex-end;
	flex-wrap: wrap;
	margin-top: 4px;
}

.footer-links a {
	color: var(--simam-text-on-dark);
	text-decoration: none;
}

.footer-links a:hover {
	color: var(--simam-orange);
}

.footer-links span {
	opacity: 0.7;
}

/* ---- Responsive ---------------------------------------------------------- */

@media (max-width: 880px) {
	.hero {
		grid-template-columns: 1fr;
		gap: 24px;
		padding: 54px 0 64px;
	}
	.hero-visual {
		min-height: 280px;
		order: -1;
	}
	.nav-links {
		display: none;
	}
	.site-footer {
		flex-direction: column;
	}
	.footer-meta,
	.footer-links {
		text-align: left;
		justify-content: flex-start;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAIF;CACC,sBAAsB;AACvB;;AAEA;;CAEC,SAAS;CACT,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,gCAAgC;CAChC,8BAA8B;CAC9B,mCAAmC;AACpC;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,+BAA+B;AAChC;;AAEA,8EAA8E;;AAE9E;CACC,gBAAgB;CAChB,SAAS;CACT,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,gBAAgB;CAChB,4BAA4B;CAC5B,kCAAkC;CAClC,mCAAmC;CACnC,uCAAuC;CACvC,2BAA2B;CAC3B,mCAAmC;AACpC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,iBAAiB;AAClB;;AAEA;CACC,mCAAmC;CACnC,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,uCAAuC;CACvC,mDAAmD;AACpD;;AAEA;CACC,gCAAgC;CAChC,qCAAqC;AACtC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,+BAA+B;CAC/B,WAAW;CACX,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,uCAAuC;CACvC,iCAAiC;AAClC;;AAEA;CACC,qCAAqC;AACtC;;AAEA,+EAA+E;;AAE/E;CACC,aAAa;CACb,oCAAoC;CACpC,mBAAmB;CACnB,SAAS;CACT,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,iBAAiB;CACjB,wBAAwB;CACxB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;CAChB,mCAAmC;CACnC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,SAAS;AACV;;AAEA;CACC,qBAAqB;AACtB;;AAEA,wEAAwE;AACxE;CACC,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,sCAAsC;AACvC;;AAEA;CACC,qCAAqC;CACrC,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA,+EAA+E;;AAE/E;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,8BAA8B;CAC9B,mCAAmC;CACnC,qCAAqC;CACrC;sBACqB;AACtB;;AAEA;CACC,2BAA2B;CAC3B,sCAAsC;CACtC,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,qBAAqB;CACrB,cAAc;CACd,OAAO;AACR;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,8CAA8C;CAC9C,4EAA4E;AAC7E;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,mCAAmC;CACnC,SAAS;CACT,OAAO;AACR;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,eAAe;CACf,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,uCAAuC;AACxC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,mCAAmC;AACpC;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,mDAAmD;AACpD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,8CAA8C;CAC9C,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA,+EAA+E;;AAE/E;CACC,gBAAgB;CAChB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,eAAe;CACf;;;;EAIC;CACD,mCAAmC;CACnC,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,iCAAiC;CACjC,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mCAAmC;CACnC,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,sCAAsC;AACvC;;AAEA;CACC,qCAAqC;CACrC,0CAA0C;AAC3C;;AAEA,+EAA+E;;AAE/E;CACC,gBAAgB;CAChB,iBAAiB;CACjB,uCAAuC;CACvC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mCAAmC;CACnC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,yBAAyB;CACzB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;AAEA,+EAA+E;;AAE/E;CACC;EACC,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;CACrB;CACA;EACC,iBAAiB;EACjB,SAAS;CACV;CACA;EACC,aAAa;CACd;CACA;EACC,sBAAsB;CACvB;CACA;;EAEC,gBAAgB;EAChB,2BAA2B;CAC5B;AACD","sourcesContent":["/*\n * Simam Digital — WebXR Showcases hub styles.\n * Standardised, near-black, brand-aligned (see simamdigital.com).\n * Copyright (c) 2026 Simam Digital Ltd.\n */\n\n@import url('../../../brand/simam-brand.css');\n\n* {\n\tbox-sizing: border-box;\n}\n\nhtml,\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\tmin-height: 100%;\n}\n\nbody {\n\tfont-family: var(--simam-font-body);\n\tcolor: var(--simam-text-on-dark);\n\tbackground: var(--simam-black);\n\t-webkit-font-smoothing: antialiased;\n}\n\n.page {\n\tmax-width: 1200px;\n\tmargin: 0 auto;\n\tpadding: 0 24px 96px;\n}\n\n.eyebrow {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 9px;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.16em;\n\tfont-size: 12.5px;\n\tfont-weight: 600;\n\tcolor: var(--simam-text-muted-dark);\n\tmargin: 0 0 18px;\n}\n\n.eyebrow::before {\n\tcontent: '';\n\twidth: 7px;\n\theight: 7px;\n\tborder-radius: 50%;\n\tbackground: var(--simam-orange);\n}\n\n/* ---- Nav (rounded pill bar) --------------------------------------------- */\n\n.nav {\n\tposition: sticky;\n\ttop: 16px;\n\tz-index: 10;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 16px;\n\tmargin: 18px 0 0;\n\tpadding: 11px 12px 11px 18px;\n\tbackground: rgba(16, 18, 24, 0.82);\n\tborder: 1px solid var(--simam-line);\n\tborder-radius: var(--simam-radius-pill);\n\tbackdrop-filter: blur(10px);\n\t-webkit-backdrop-filter: blur(10px);\n}\n\n.nav-brand {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 11px;\n\ttext-decoration: none;\n}\n\n.nav-logo {\n\twidth: 34px;\n\theight: 34px;\n\tdisplay: block;\n}\n\n.nav-logo svg {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n}\n\n.nav-wordmark {\n\tfont-weight: 800;\n\tfont-size: 17px;\n\tletter-spacing: 0.04em;\n\tcolor: var(--simam-text-on-dark);\n}\n\n.nav-links {\n\tdisplay: flex;\n\tgap: 4px;\n\tmargin-left: auto;\n}\n\n.nav-links a {\n\tcolor: var(--simam-text-muted-dark);\n\ttext-decoration: none;\n\tfont-size: 14.5px;\n\tfont-weight: 500;\n\tpadding: 9px 16px;\n\tborder-radius: var(--simam-radius-pill);\n\ttransition: background 0.15s ease, color 0.15s ease;\n}\n\n.nav-links a:hover {\n\tcolor: var(--simam-text-on-dark);\n\tbackground: rgba(255, 255, 255, 0.06);\n}\n\n.nav-cta {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 8px;\n\tbackground: var(--simam-orange);\n\tcolor: #fff;\n\ttext-decoration: none;\n\tfont-size: 14.5px;\n\tfont-weight: 600;\n\tpadding: 11px 20px;\n\tborder-radius: var(--simam-radius-pill);\n\ttransition: background 0.15s ease;\n}\n\n.nav-cta:hover {\n\tbackground: var(--simam-orange-hover);\n}\n\n/* ---- Hero ---------------------------------------------------------------- */\n\n.hero {\n\tdisplay: grid;\n\tgrid-template-columns: 1.05fr 0.95fr;\n\talign-items: center;\n\tgap: 48px;\n\tpadding: 86px 0 96px;\n}\n\n.hero-title {\n\tfont-weight: 800;\n\tfont-size: clamp(40px, 5.6vw, 66px);\n\tline-height: 1.03;\n\tletter-spacing: -0.025em;\n\tmargin: 0;\n\tmax-width: 13ch;\n}\n\n.hero-sub {\n\tfont-size: clamp(16px, 1.5vw, 18.5px);\n\tline-height: 1.6;\n\tcolor: var(--simam-text-muted-dark);\n\tmargin: 22px 0 32px;\n\tmax-width: 50ch;\n}\n\n.hero-cta {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 12px;\n}\n\n.hero-cta a {\n\ttext-decoration: none;\n}\n\n/* Re-skin shared buttons for the standardised hub look (no lift/glow) */\n.hero-cta .simam-btn {\n\tfont-family: var(--simam-font-body);\n\tbox-shadow: none;\n}\n\n.hero-cta .simam-btn:hover {\n\ttransform: none;\n\tfilter: none;\n}\n\n.hero-cta .simam-btn--ghost {\n\tcolor: var(--simam-text-on-dark);\n\tborder-color: var(--simam-line-strong);\n}\n\n.hero-cta .simam-btn--ghost:hover {\n\tbackground: rgba(255, 255, 255, 0.06);\n\tborder-color: var(--simam-text-muted-dark);\n}\n\n.hero-hint {\n\tmargin-top: 24px;\n\tfont-size: 13px;\n\tcolor: var(--simam-text-muted-dark);\n\topacity: 0.8;\n}\n\n.hero-visual {\n\tposition: relative;\n\twidth: 100%;\n\tmin-height: 420px;\n\theight: 100%;\n}\n\n#hero-canvas {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n}\n\n/* ---- Showcases ----------------------------------------------------------- */\n\n.section-head {\n\tmargin-bottom: 30px;\n}\n\n.section-title {\n\tfont-weight: 800;\n\tfont-size: clamp(26px, 3.4vw, 38px);\n\tletter-spacing: -0.02em;\n\tmargin: 0;\n}\n\n.card-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(270px, 1fr));\n\tgap: 20px;\n}\n\n.card {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 26px;\n\tbackground: var(--simam-panel);\n\tborder: 1px solid var(--simam-line);\n\tborder-radius: var(--simam-radius-lg);\n\ttransition: transform 0.2s ease, border-color 0.2s ease,\n\t\tbackground 0.2s ease;\n}\n\n.card:hover {\n\ttransform: translateY(-4px);\n\tborder-color: var(--simam-line-strong);\n\tbackground: var(--simam-panel-2);\n}\n\n.card-main {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 14px;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tflex: 1;\n}\n\n.card-chip {\n\twidth: 46px;\n\theight: 46px;\n\tborder-radius: 13px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--card-accent, var(--simam-violet));\n\tbackground: color-mix(in srgb, var(--card-accent, #a855f7) 16%, transparent);\n}\n\n.card-chip svg {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.card-eyebrow {\n\ttext-transform: uppercase;\n\tletter-spacing: 0.13em;\n\tfont-size: 11.5px;\n\tfont-weight: 600;\n\tcolor: var(--simam-text-muted-dark);\n}\n\n.card-title {\n\tfont-weight: 700;\n\tfont-size: 20px;\n\tletter-spacing: -0.01em;\n\tmargin: 0;\n}\n\n.card-desc {\n\tfont-size: 14.5px;\n\tline-height: 1.55;\n\tcolor: var(--simam-text-muted-dark);\n\tmargin: 0;\n\tflex: 1;\n}\n\n.card-launch {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 7px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tcolor: var(--simam-text-on-dark);\n\tmargin-top: 4px;\n}\n\n.card-launch span {\n\ttransition: transform 0.18s ease;\n}\n\n.card:hover .card-launch {\n\tcolor: var(--card-accent, var(--simam-violet));\n}\n\n.card:hover .card-launch span {\n\ttransform: translateX(4px);\n}\n\n.card-foot {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 10px;\n\tflex-wrap: wrap;\n\tmargin-top: 18px;\n\tpadding-top: 14px;\n\tborder-top: 1px solid var(--simam-line);\n}\n\n.card-stat {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 7px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: var(--simam-text-muted-dark);\n}\n\n.card-stat::before {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tborder-radius: 50%;\n\tbackground: var(--card-accent, var(--simam-violet));\n}\n\n.card-cs {\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tcolor: var(--card-accent, var(--simam-violet));\n\ttext-decoration: none;\n\twhite-space: nowrap;\n}\n\n.card-cs:hover {\n\ttext-decoration: underline;\n}\n\n/* ---- Funnel band --------------------------------------------------------- */\n\n.funnel {\n\tmargin-top: 64px;\n\tpadding: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 32px;\n\tflex-wrap: wrap;\n\tbackground: linear-gradient(\n\t\t135deg,\n\t\tvar(--simam-panel-2),\n\t\tvar(--simam-panel)\n\t);\n\tborder: 1px solid var(--simam-line);\n\tborder-radius: var(--simam-radius-lg);\n}\n\n.funnel-copy {\n\tmax-width: 620px;\n}\n\n.funnel-title {\n\tfont-weight: 800;\n\tfont-size: clamp(22px, 3vw, 30px);\n\tletter-spacing: -0.02em;\n\tmargin: 6px 0 12px;\n}\n\n.funnel-sub {\n\tfont-size: 15px;\n\tline-height: 1.6;\n\tcolor: var(--simam-text-muted-dark);\n\tmargin: 0;\n}\n\n.funnel-cta {\n\tdisplay: flex;\n\tgap: 12px;\n\tflex-wrap: wrap;\n}\n\n.funnel-cta a {\n\ttext-decoration: none;\n}\n\n.funnel-cta .simam-btn {\n\tfont-family: var(--simam-font-body);\n\tbox-shadow: none;\n}\n\n.funnel-cta .simam-btn:hover {\n\ttransform: none;\n\tfilter: none;\n}\n\n.funnel-cta .simam-btn--ghost {\n\tcolor: var(--simam-text-on-dark);\n\tborder-color: var(--simam-line-strong);\n}\n\n.funnel-cta .simam-btn--ghost:hover {\n\tbackground: rgba(255, 255, 255, 0.06);\n\tborder-color: var(--simam-text-muted-dark);\n}\n\n/* ---- Footer -------------------------------------------------------------- */\n\n.site-footer {\n\tmargin-top: 72px;\n\tpadding-top: 30px;\n\tborder-top: 1px solid var(--simam-line);\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 24px;\n\tflex-wrap: wrap;\n}\n\n.footer-brand .nav-wordmark {\n\tfont-size: 16px;\n}\n\n.footer-meta {\n\tfont-size: 13px;\n\tcolor: var(--simam-text-muted-dark);\n\ttext-align: right;\n\tline-height: 1.7;\n}\n\n.footer-links {\n\tdisplay: flex;\n\tgap: 16px;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n\tmargin-top: 4px;\n}\n\n.footer-links a {\n\tcolor: var(--simam-text-on-dark);\n\ttext-decoration: none;\n}\n\n.footer-links a:hover {\n\tcolor: var(--simam-orange);\n}\n\n.footer-links span {\n\topacity: 0.7;\n}\n\n/* ---- Responsive ---------------------------------------------------------- */\n\n@media (max-width: 880px) {\n\t.hero {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 24px;\n\t\tpadding: 54px 0 64px;\n\t}\n\t.hero-visual {\n\t\tmin-height: 280px;\n\t\torder: -1;\n\t}\n\t.nav-links {\n\t\tdisplay: none;\n\t}\n\t.site-footer {\n\t\tflex-direction: column;\n\t}\n\t.footer-meta,\n\t.footer-links {\n\t\ttext-align: left;\n\t\tjustify-content: flex-start;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
